<template>
  <div class="reembolso">
   
    <div class="contenedorDev">
       <h4>
      <i class="el-icon-refresh-left"></i>
      Información de reembolso
    </h4>
      <table class="table table-items">
        <tr>
          <th>Fecha</th>
          <td>{{ datos.fechaDevolucion }}</td>
        </tr>
        <tr>
          <th>Motivo</th>
          <td>{{ datos.motivoDevolucion }}</td>
        </tr>
        <tr class="">
          <th style="color: #BFBE51">Dinero reembolsado</th>
          <td style="color: #BFBE51">
            <strong>
              {{
                datos.devuelto
                  | currency("$", 2, { thousandsSeparator: ".", decimalSeparator: "," })
              }}</strong
            >
          </td>
        </tr>
        <!-- <tr>
          <th>Total abonado</th>
          <td>
            {{
              datos.total
                | currency("$", 2, { thousandsSeparator: ".", decimalSeparator: "," })
            }}
          </td>
        </tr> -->
        <tr>
          <th>Estado de la operación</th>
          <td>
            {{ (datos.datosDevolucion[0].estado || "") | estadoReembolso }}
          </td>
        </tr>
      </table>
      <!-- <h4 style="background: #42bd87; margin-bottom: 0px">Seguimiento del reembolso</h4>
      <table
        class="table table-sm table-bordered table-striped"
        style="text-align: center"
      >
        <thead>
          <tr>
           
            <td>Fecha</td>
            <td>Importe</td>
            <td>Estado</td>
          </tr>
        </thead>
        <tbody>
          <template v-if="datos.seguimiento">
            <tr v-for="item in datos.datosDevolucion" :key="item.ID">
            
              <td>{{ $date(item.fecope.date).format("DD/MM/YYYY HH:mm") }}</td>
              <td>
                {{
                  item.impdev
                    | currency("$", 2, { thousandsSeparator: ".", decimalSeparator: "," })
                }}
              </td>
              <td>{{ item.estado | estadoReembolso }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="4" style="text-align: center">
              La entidad bancaria aún no ha actualizado la información de reembolso.
            </td>
          </tr>
        </tbody>
      </table> -->

      <small style="" class="info-devolucion">
        <strong style="">IMPORTANTE:</strong> La devolución del dinero se realiza
        automáticamente por el mismo medio de pago con el que abonaste. Te informamos los
        tiempos estimados de cada uno:
        <ul style="margin-top: 0px">
          <li>Billetera Mercado Pago: 72 Hs.</li>
          <li>Tarjeta de Débito o Crédito: 2 a 35 días</li>
        </ul>
        (estos plazos dependen de tu banco y el cierre mensual de cada tarjeta)
      </small>
    </div>
  </div>
</template>

<script>
import { ESTADO_REEMBOLSO } from "../helpers/helpers";
export default {
  props: {
    datos: {
      type: Object,
      required: true,
    },
  },

  name: "informacionDevolucion",

  filters: {
    estadoReembolso(estado) {
      return ESTADO_REEMBOLSO[estado];
    },
  },
};
</script>

<style lang="css" scoped>
.reembolso {
  margin-top:10px ;
}
.reembolso h4 {
  margin: 0px;
  text-align: left;
  padding: 10px;
  
}
.contenedorDev {
  border: 2px solid #e9e9e9;
  /* padding: 10px; */
  padding-top: 0px;
  padding-bottom: 5px;
  border-radius: 4px;
}
tr.trReem > th {
  padding: 15px 0 !important;
  background-color: #f7f6cf !important;
  font-weight: bold !important;
}
tr.trReem > td {
  background-color: #f7f6cf !important;
  /* padding: 10px !important; */
  color: #333;
  font-weight: bold !important;
}
.table-items > tr > th {
  padding: 1px 20px;
  width: 180px;
}
.table-items > tr > td {
  padding-left: 5px;
  text-align: justify;
}
.info-devolucion {
  /* float: left; */
  display: block;
  font-size: 13.5px;
  /* padding-top : 5px; */
  text-align: left;
  /* border-top: 1px dashed hsl(0, 82%, 67%); */
  margin-top: 0px;
  padding: 0px 20px;
}
.info-devolucion > strong {
  color: #BFBE51;
  font-weight: 500er;
}
</style>
